export default {
  common: {
    loading: 'Loading...',
    loadFail: 'Failed to load',
    noMore: 'No more listings',
    reset: 'Reset',
    confirm: 'Confirm',
    cancel: 'Cancel',
    yes: 'Yes',
    no: 'No',
  },
  notice: {
    title: 'Notices',
    searchPlaceholder: 'Search notices',
    search: 'Search',
    noMore: 'No more notices',
    read: 'Read',
    unread: 'Unread',
    edit: 'Edit',
    detail: 'Details',
    readCount: '{n} read',
  },
  rental: {
    topBarTitle: 'Rental Housing',
    title: 'Rental Housing',
    publish: 'Publish',
    sortDefault: 'Default',
    sortPrice: 'Price',
    sortTime: 'Latest',
    callPhone: 'Call',
    fiveStar: 'Five-Star Landlord',
    newListing: 'New',
    buildingUnit: '',
    priceFrom: 'From ¥{price}',
    priceRange: '¥{min} - ¥{max}',
    mr: 'Mr. {surname}',
    ms: 'Ms. {surname}',
  },
  tenantRating: {
    title: 'Rate Property',
    livingExperience: 'Living Experience',
    cleanliness: 'Safety Management',
    serviceAttitude: 'Service Attitude',
    submitReview: 'Submit Review',
    poor: 'Poor',
    needsImprovement: 'Needs Improvement',
    satisfied: 'Satisfied',
    veryGood: 'Very Good',
    excellent: 'Excellent',
    missingProperty: 'Missing property info',
    submitting: 'Submitting...',
    submitSuccess: 'Submit Success',
    submitFail: 'Submit Failed',
  },
  rentalDetail: {
    monthlyRent: 'Monthly Rent',
    description: 'Description',
    facilities: 'Facilities',
    photos: 'Photos',
    perMonth: '/mo',
  },
  saveCode: {
    pageTitle: 'Landlord Grid',
    login: 'Login',
    selfRegister: 'Register',
    guestRegister: 'Tenant Registration',
    staffInfo: 'Staff Information',
    notice: 'Notices',
    checkInNotice: 'Check-in Notice',
    clickToView: 'Click to view rental terms',
    verifyPhone: 'Phone Number',
    verifyCode: 'Verification Code',
    sendCode: 'Send Code',
    verifyPlaceholder: 'Enter phone number',
    codePlaceholder: 'Enter verification code',
    quickReport: 'Quick Report',
    quickReportDesc: 'Snap community issues, instant feedback',
    selfCheck: 'Self-Check',
    selfCheckDesc: 'Self-inspect and rectify promptly',
    needHelp: 'Help',
    needHelpDesc: 'One-click fire rescue for safety',
    safetyPromo: 'Safety Promotion',
    safetyPromoDesc: 'Safety reminder of the day',
    viewAll: 'View All',
    cancel: 'Cancel',
    confirm: 'Confirm',
  },
  newRegister: {
    step1: '1. Select Type',
    step2: '2. Registration',
    householdType: 'Household Type',
    multiSelect: ' (Multi-select)',
    iHaveReadAndAgree: 'I have read and agree',
    checkInNotice: 'Check-in Notice',
    pleaseRead: '(Please read {n}s)',
    next: 'Next',
    checkInNoticeTitle: 'Check-in Notice',
    pleaseAgreeNotice: 'Please agree to the check-in notice',
    pleaseSelectHouseholdType: 'Please select household type',
    localTenant: 'I am a local hukou tenant',
    nonLocalTenant: 'I am a non-local hukou tenant',
    foreignNational: 'I am a foreign national',
    scanHint: 'Scan ID to auto-fill personal information',
    uploadPhoto: 'Upload Photo',
    clickToUpload: 'Click to Upload',
    residenceInfo: 'Residence Information',
    rentalInfo: 'Rental Information',
    tagInfo: 'Tags',
    submit: 'Submit',
    selectBirthday: 'Select Birthday',
    selectDate: 'Select Date',
    pleaseSelect: 'Please Select',
    idNumberTypeRequired: 'Please select ID type',
    idNumberValid: 'Please enter valid ID number',
    idNumberRequired: 'Please enter ID number',
    nameRequired: 'Please enter name',
    sexRequired: 'Please select gender',
    mobileInvalid: 'Please enter valid phone number',
    nationalityRequired: 'Please select nationality',
    nationRequired: 'Please select ethnicity',
    birthdayRequired: 'Please select birthday',
    regAddressRequired: 'Please enter registered address',
    houseRequired: 'Please select residence',
    relationshipRequired: 'Please select relationship to homeowner',
    roomRequired: 'Please enter room number',
    nowAddressRequired: 'Please enter current address',
    rentStartRequired: 'Please select lease start date',
    rentEndRequired: 'Please select lease end date',
    sameTimeError: 'Start and end time cannot be the same',
    startEndError: 'Lease start date cannot be later than or equal to end date',
    confirmSubmit: 'Confirm submission?',
    submitSuccess: 'Success',
    submitAudit: 'Information submitted for review',
    saveSuccess: 'Saved successfully',
    tenantSelfRegister: 'Tenant Self-Registration',
    tenant: 'Tenant',
    idCard: 'ID Card',
    passport: 'Passport',
    hkMacaoTaiwan: 'HK/Macao/Taiwan Pass',
    policeCard: 'Police ID',
    militaryCard: 'Military ID',
    otherCertificate: 'Other',
    noCertificate: 'None',
    registerSuccess: 'Registration Successful',
    registerTime: 'Registration Time: ',
    idNumberTypeLabel: 'ID Type',
    idNumberTypePlaceholder: 'Select ID type',
    idNumberLabel: 'ID Number',
    idNumberPlaceholder: 'Enter valid ID number',
    idNumberPlaceholderOther: 'Enter ID number',
    nameLabel: 'Name',
    namePlaceholder: 'Enter name',
    sexLabel: 'Gender',
    sexPlaceholder: 'Select gender',
    sexMale: 'Male',
    sexFemale: 'Female',
    mobileLabel: 'Phone Number',
    mobilePlaceholder: 'Enter phone number',
    nationalityLabel: 'Nationality',
    nationalityPlaceholder: 'Select nationality',
    nationLabel: 'Ethnicity',
    nationPlaceholder: 'Select ethnicity',
    nativePlaceLabel: 'Place of Origin',
    nativePlacePlaceholder: 'Select place of origin',
    birthdayLabel: 'Date of Birth',
    birthdayPlaceholder: 'Select date of birth',
    companyLabel: 'Company',
    companyPlaceholder: 'Enter company name',
    emContactLabel: 'Emergency Contact',
    emContactPlaceholder: 'Enter emergency contact name',
    emMobileLabel: 'Contact Phone',
    emMobilePlaceholder: 'Enter contact phone number',
    regAddressLabel: 'Registered Address',
    regAddressPlaceholder: 'Enter registered address',
    houseLabel: 'Residence',
    housePlaceholder: 'Select residence',
    relationshipLabel: 'Relationship to Homeowner',
    relationshipPlaceholder: 'Select relationship',
    roomLabel: 'Room Number',
    roomPlaceholder: 'e.g. Room 1',
    nowAddressLabel: 'Current Address',
    nowAddressPlaceholder: 'Enter current address',
    moveInDateLabel: 'Move-in Date',
    moveInDatePlaceholder: 'Select move-in date',
    rentStartLabel: 'Lease Start Date',
    rentStartPlaceholder: 'Select lease start date',
    rentEndLabel: 'Lease End Date',
    rentEndPlaceholder: 'Select lease end date',
    partyMember: 'Party Member',
    veteran: 'Veteran',
    disabled: 'Disabled',
  },
  activity: {
    title: 'Activities',
    all: 'All Activities',
    signed: 'Registered',
    search: 'Search',
    searchPh: 'Search activities',
    type: 'Type',
    startDate: 'Start Date',
    endDate: 'End Date',
    datePick: 'Select Date',
    noMore: 'No more',
    totalCount: '{n} result(s)',
    unlimited: 'Unlimited',
    capacity: 'Capacity: ',
    signCount: 'Registered: ',
    remaining: 'Remaining: ',
    noSign: 'No registration',
    deadline: 'Deadline',
    signedIn: 'Checked in',
    signedUp: 'Registered',
    signEnded: 'Registration ended',
    inProgress: 'In progress',
    ended: 'Ended',
    time: 'Time: ',
    to: ' to ',
    peopleUnit: '',
    activitySuffix: ' Activity',
    detail: 'Activity Details',
    notice: 'Notice',
    location: 'Location: ',
    deadlineTime: 'Registration Deadline: ',
    signUp: 'Sign Up',
    cancelSign: 'Cancel',
    signingUp: 'Signing up...',
    signUpOk: 'Sign up successful',
    confirmCancel: 'Confirm cancellation?',
    cancelOk: 'Cancelled',
    signInOk: 'Check-in successful!',
    typeLoadFail: 'Failed to load activity types',
    startAfterEnd: 'Start date cannot be after end date',
    endBeforeStart: 'End date cannot be before start date',
    resident: 'Resident',
    socialWorker: 'Community Worker',
    ms: 'Ms.',
    mr: 'Mr.',
  },
};
